import { InpaintingPanel } from "@/modules/editor/components/common/InpaintingPanel";
import { getTxt2ImgMetaData } from "@/modules/editor/utils/meta";
import { statusStore } from "@/stores/status";
import { Actions } from "@/utils/api";
import { Editor_Words } from "@/utils/lang/editor";
import { useOwnToast } from "@/utils/misc";
import { isAuthUser, isVip } from "@/utils/status";
import { flagsStore, langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { getNodeDisplayWH } from "../../utils/misc";
import BizGenerateButton from "@/components/bussiness/BizGenerateButton";
import { GeneratePriceRules } from "../../hooks/useGenerateCost";
import { GenerateBizType } from "@/types/creator";

const LocalReplace: React.FC = () => {
  const toastFn = useOwnToast();
  const lang = langStore.tgt;
  const text = statusStore.txt2imgTexts;
  const imageAlias = statusStore.inpaintingImageAlias;
  const maskAlias = statusStore.inpaintingMaskAlias;
  const wh = useMemo(() => getNodeDisplayWH(imageAlias), [imageAlias, flagsStore.latestOpTime]);

  const generateCount = useMemo(() => {
    return isAuthUser() && isVip() ? statusStore.generateCount : 1;
  }, [isVip(), isAuthUser(), statusStore.generateCount]);

  const btnText = useMemo(() => {
    if (!generateCount || generateCount === 1) {
      const text = translate(Editor_Words["txt2img-inpainting-submit"], lang);
      return text;
    } else {
      return translate(Editor_Words["txt2img-inpainting-submit-and-add-template"], lang).replace(
        "$1",
        generateCount.toString(),
      );
    }
  }, [generateCount]);

  async function onInpainting(): Promise<void> {
    await Actions.inpaintingWithBGFG({
      t: toastFn,
      lang,
      bgAlias: imageAlias,
      fgAlias: maskAlias,
      opt: {
        type: "txt2img.inpainting",
        useFGAsImage: false,
        txt2imgMetaData: getTxt2ImgMetaData({
          lang,
          text,
          circular: false,
          modelType: "nolibox",
          displayNode: null,
          originalNegative: statusStore.negativePrompt,
        }),
        generateCount,
      },
      noToast: false,
      checkBusy: !isVip(),
    });
  }

  return (
    <InpaintingPanel
      titleWord={Editor_Words["txt2img-inpainting-title"]}
      labelWord={Editor_Words["local-replace-image-placeholder-title"]}
      // markAsMaskWord={Editor_Words["txt2img-inpainting-mark-mask"]}
      maskTitleWord={Editor_Words["local-replace-mask-placeholder-title"]}
      extraRenderConfig={{
        textArea: {
          titleWord: Editor_Words["local-replace-content"],
        },
        generateCountInput: {},
      }}
      submitPanel={
        <BizGenerateButton
          sticky
          mt="16px"
          size={wh ?? { w: 0, h: 0 }}
          generateCount={generateCount}
          calcPriceProps={GeneratePriceRules[GenerateBizType.Replace]}
          buttonProps={{
            isDisabled: !imageAlias || !maskAlias,
          }}
          onSubmit={onInpainting}
        >
          {btnText}
        </BizGenerateButton>
      }
    />
  );
};

export default observer(LocalReplace);
